// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + "vendor" + "." + "46e0d7c7e0bf8e9f79df" + ".js"
}